module.exports = __webpack_public_path__ + "img/Cart-bucket.66624df1.svg";